import HttpClient from '@src/shared/services/base/http-client';
import MCPMarketEnvironmentDetection, {
  MCP_MARKET_ENVIRONMENT_COUNTRY_CODES,
} from '@src/shared/utils/market-environment-detection';

export type TTips = {
  showTips: boolean;
};

export type TGetTips = () => Promise<TTips>;
export type TUpdateTips = (data: boolean) => Promise<TTips>;

class ResturantSettingsApiService extends HttpClient {
  constructor(baseURL: string, authHeaderName: string) {
    super(baseURL, authHeaderName);
  }

  public getTips: TGetTips = () => {
    return this.instance.get('/settings');
  };
  public updateTips: TUpdateTips = (showTips: boolean) => {
    return this.instance.put('/settings', {
      showTips,
    });
  };
}

const getBaseUrl = () => {
  const { countryCode } = MCPMarketEnvironmentDetection.getMarketEnvironment();
  if (countryCode === MCP_MARKET_ENVIRONMENT_COUNTRY_CODES.UK) {
    return process.env.RESTAURANT_SETTINGS_API_URL_EU_WEST as string;
  }
  return process.env.RESTAURANT_SETTINGS_API_URL_EU_CENTRAL as string;
};

export default new ResturantSettingsApiService(getBaseUrl(), 'X-Auth');
